import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getTransactions = createAsyncThunk(
  "transactions/getTransactions",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().transactions;
      if (state.count.getTransactions <= 1) {
        const res = await axios.get("/transactions", { params: reqData });
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getMethodTypes = createAsyncThunk(
  "transactions/getMethodTypes",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().transactions;
      if (state.count.getMethodTypes <= 1) {
        const res = await axios.get("/transactions/types", { params: reqData });
        return res.data;
      }
      return state.methodTypes;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const getMethodType = createAsyncThunk(
  "transactions/getMethodType",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/method-type/" + reqData);

      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addMethodType = createAsyncThunk(
  "transactions/addMethodType",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-method-type", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const editMethodType = createAsyncThunk(
  "transactions/editMethodType",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-method-type/" + id, data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteMethodType = createAsyncThunk(
  "transactions/deleteMethodType",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-method-type/" + id, {
        params: data,
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

/**
 *
 *
 * Transactions
 */

export const addTransaction = createAsyncThunk(
  "transactions/addTransaction",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/transactions/create", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const editTransaction = createAsyncThunk(
  "transactions/editTransaction",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteTransaction = createAsyncThunk(
  "transactions/deleteTransaction",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: {
    methodTypes: [],
    data: [],
    selected: {},
    selectedType: {},
    loading: false,
    error: null,
    load: {
      getMethodTypes: false,
      getMethodType: false,
      addMethodType: false,
      editMethodType: false,
      deleteMethodType: false,

      getTransactions: false,
      getTransaction: false,
      addTransaction: false,
      editTransaction: false,
      deleteTransaction: false,
      getMethodTypes: false,
    },
    count: { getTransactions: 0, getTransaction: 0, getMethodTypes: 0 },
  },
  reducers: {
    setTransactions: (state, action) => {
      state.data = action.payload;
    },
    setSelectedTransaction: (state, action) => {
      state.selected = action.payload;
    },
    unsetTransactions: (state) => {
      state.data = [];
      state.selected = {};
    },
    unsetSelectedTransaction: (state) => {
      state.selected = {};
    },
    unsetMethodTypes: (state) => {
      state.methodTypes = [];
      state.selectedType = {};
    },
    unsetSelectedType: (state) => {
      state.selectedType = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Method Types
      .addCase(getMethodTypes.pending, (state) => {
        state.load.getMethodTypes = loadStatus.loading;
        state.error = null;
        state.count.getMethodTypes = ++state.count.getMethodTypes;
      })
      .addCase(getMethodTypes.fulfilled, (state, action) => {
        state.load.getMethodTypes = loadStatus.success;
        state.methodTypes = action.payload;
        state.count.getMethodTypes = 0;
      })
      .addCase(getMethodTypes.rejected, (state, action) => {
        state.load.getMethodTypes = loadStatus.error;
        state.error = action.payload;
        state.count.getMethodTypes = 0;
      })
      //Get Method Type
      .addCase(getMethodType.pending, (state) => {
        state.load.getMethodType = loadStatus.loading;
        state.error = null;
      })
      .addCase(getMethodType.fulfilled, (state, action) => {
        state.load.getMethodType = loadStatus.success;
        state.selectedType = action.payload;
      })
      .addCase(getMethodType.rejected, (state, action) => {
        state.load.getMethodType = loadStatus.error;
        state.error = action.payload;
      })
      //Add Method Types
      .addCase(addMethodType.pending, (state) => {
        state.load.addMethodType = loadStatus.loading;
        state.error = null;
      })
      .addCase(addMethodType.fulfilled, (state, action) => {
        state.load.addMethodType = loadStatus.success;
        state.selectedType = action.payload;
        state.methodTypes.unshift(action.payload);
      })
      .addCase(addMethodType.rejected, (state, action) => {
        state.load.addMethodType = loadStatus.error;
        state.error = action.payload;
      })
      //Edit Method Types
      .addCase(editMethodType.pending, (state) => {
        state.load.editMethodType = loadStatus.loading;
        state.error = null;
      })
      .addCase(editMethodType.fulfilled, (state, action) => {
        state.load.editMethodType = loadStatus.success;
        state.selectedType = action.payload;
        const index = state.methodTypes.findIndex(
          (item) => (item.id = action.payload.id)
        );
        if (index !== -1) {
          state.methodTypes[index] = action.payload;
        }
      })
      .addCase(editMethodType.rejected, (state, action) => {
        state.load.editMethodType = loadStatus.error;
        state.error = action.payload;
      })
      //Delete Method Types
      .addCase(deleteMethodType.pending, (state) => {
        state.load.deleteMethodType = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteMethodType.fulfilled, (state, action) => {
        state.load.deleteMethodType = loadStatus.success;
        state.methodTypes.filter((item) => item.id !== action.meta.arg.id);
      })
      .addCase(deleteMethodType.rejected, (state, action) => {
        state.load.deleteMethodType = loadStatus.error;
        state.error = action.payload;
      })
      //Get all Transactions
      .addCase(getTransactions.pending, (state) => {
        state.load.getTransactions = loadStatus.loading;
        state.error = null;
        state.count.getTransactions = ++state.count.getTransactions;
      })
      .addCase(getTransactions.fulfilled, (state, action) => {
        state.load.getTransactions = loadStatus.success;
        state.data = action.payload;
        state.count.getTransactions = 0;
      })
      .addCase(getTransactions.rejected, (state, action) => {
        state.load.getTransactions = loadStatus.error;
        state.error = action.payload;
        state.count.getTransactions = 0;
      })
      //Add Transactions
      .addCase(addTransaction.pending, (state) => {
        state.load.addTransaction = loadStatus.loading;
        state.error = null;
      })
      .addCase(addTransaction.fulfilled, (state, action) => {
        state.load.addTransaction = loadStatus.success;
      })
      .addCase(addTransaction.rejected, (state, action) => {
        state.load.addTransaction = loadStatus.error;
        state.error = action.payload;
      })
      //Update Transactions
      .addCase(editTransaction.pending, (state) => {
        state.load.editTransaction = loadStatus.loading;
        state.error = null;
      })
      .addCase(editTransaction.fulfilled, (state, action) => {
        state.load.editTransaction = loadStatus.success;
        const index = state.data.findIndex(
          (item) => (item.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editTransaction.rejected, (state, action) => {
        state.load.editTransaction = loadStatus.error;
        state.error = action.payload;
      })
      //Delete Transactions
      .addCase(deleteTransaction.pending, (state) => {
        state.load.deleteTransaction = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteTransaction.fulfilled, (state, action) => {
        state.load.deleteTransaction = loadStatus.success;
        state.data.filter((item) => item.id !== action.meta.arg.id);
      })
      .addCase(deleteTransaction.rejected, (state, action) => {
        state.load.deleteTransaction = loadStatus.error;
        state.error = action.payload;
      });
  },
});

export const {
  setTransactions,
  setSelectedTransaction,
  unsetTransactions,
  unsetSelectedTransaction,
  unsetMethodTypes,
  unsetSelectedType,
} = transactionsSlice.actions;
export default transactionsSlice.reducer;
